import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { FAQ } from "../template_offering_details_common";

import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { useMercuryCenterAnalytics } from "./mercury-center_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./mercury-center_partner_config";

const Theme = lazyWithRetry(() => import("./mercury-center_theme"));

// TODO: add missing FAQs when available
const faqs: FAQ[] = [];

export function OfferingMercuryCenterDayOffice() {
  useMercuryCenterAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description:
            "Book a team room for privacy and a productive setting to get through your work.",
          testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
